

window['_tmr'] = window['_tmr'] || [];

import { tmrProductView } from './tmr-product-view';
import { tmrCartViewAddProducts } from './tmr-cart-view-add-products';
import { tmrCostumeViewAddCart } from './tmr-costume-view-add-cart';
import { tmrOpenBasket } from './tmr-open-basket';
import { tmrPurchase } from './tmr-purchase';
import { tmrHomeView } from './tmr-home-view';
import { tmrSearchresultsView } from './tmr-search-results-view';
import { tmrCategoryView } from './tmr-category-view';
import { tmrOtherView } from './tmr-other-view';

export {
	tmrProductView,
	tmrCartViewAddProducts,
	tmrCostumeViewAddCart,
	tmrOpenBasket,
	tmrPurchase,
	tmrHomeView,
	tmrSearchresultsView,
	tmrCategoryView,
	tmrOtherView,
}